module.exports = __webpack_public_path__ + "static/media/recipiente2.540bf2ad.jpg";